import Typography from '@components/Typography';
import { concatStyles } from '@styles/domain';
import { HTMLAttributes, type FC } from 'react';
import * as styles from './index.css';

interface Props extends HTMLAttributes<HTMLSpanElement> {
  label: string;
  color: keyof typeof styles.colors;
}

const Chip: FC<Props> = ({ label, color, className, ...rest }) => (
  <Typography
    variant='body3'
    {...rest}
    className={concatStyles([styles.base, styles.colors[color], className])}
  >
    {label}
  </Typography>
);

export default Chip;
